import { useEffect, useState } from "react";
import PageHero from "@/components/shared/PageHero";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import api from "@/lib/api";

export default function FAQPage() {
  const [faqs, setFaqs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  const cats = Array.from(new Set(faqs.map((f) => f.category || "General")));
  const filtered = q
    ? faqs.filter((f) => (f.question + " " + f.answer).toLowerCase().includes(q.toLowerCase()))
    : faqs;

  return (
    <div>
      <PageHero
        label="Frequently Asked Questions"
        title="Answers for retailers and distributors."
        subtitle="Straight, honest answers to the questions our business partners ask us most."
        breadcrumbs={[{ label: "FAQ" }]}
      />
      <section className="py-14">
        <div className="mx-auto max-w-4xl px-4 md:px-8">
          <div className="relative mb-10">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground/50" />
            <Input
              data-testid="faq-search"
              placeholder="Search FAQs..."
              value={q}
              onChange={(e) => setQ(e.target.value)}
              className="pl-10 h-12 rounded-sm bg-card"
            />
          </div>
          {q ? (
            <Accordion type="single" collapsible className="w-full space-y-2">
              {filtered.map((f) => (
                <AccordionItem key={f.id} value={f.id} className="border border-border/60 rounded-md px-5">
                  <AccordionTrigger className="text-left font-serif text-lg py-5 hover:text-gold">{f.question}</AccordionTrigger>
                  <AccordionContent className="text-foreground/70 pb-5 leading-relaxed">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          ) : (
            cats.map((cat) => {
              const list = faqs.filter((f) => (f.category || "General") === cat);
              if (list.length === 0) return null;
              return (
                <div key={cat} className="mb-10">
                  <p className="section-label mb-4"><span className="inline-block w-8 h-px bg-gold align-middle mr-3" />{cat}</p>
                  <Accordion type="single" collapsible className="w-full space-y-2">
                    {list.map((f) => (
                      <AccordionItem key={f.id} value={f.id} className="border border-border/60 rounded-md px-5">
                        <AccordionTrigger className="text-left font-serif text-lg py-5 hover:text-gold">{f.question}</AccordionTrigger>
                        <AccordionContent className="text-foreground/70 pb-5 leading-relaxed">{f.answer}</AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </div>
              );
            })
          )}
        </div>
      </section>
    </div>
  );
}
